module.exports = "pegasus/assets/themelp1/small/3.png";